(function () {
  'use strict';

  /* ── Gallery ────────────────────────────────────────────────────────────── */
  function initGallery() {
    var thumbs = document.querySelectorAll('.main-product__thumb');
    var mainImg = document.getElementById('main-product-image');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');

        var newSrc = thumb.dataset.src;
        var newSrcset = thumb.dataset.srcset;
        if (newSrc) mainImg.src = newSrc;
        if (newSrcset) mainImg.srcset = newSrcset;
        mainImg.alt = thumb.getAttribute('aria-label') || mainImg.alt;
      });
    });
  }

  /* ── Variant Picker ─────────────────────────────────────────────────────── */
  function initVariantPicker() {
    var pills = document.querySelectorAll('.main-product__option-pill');
    var variantInput = document.getElementById('main-product-variant-id');
    var priceEl = document.getElementById('main-product-price');
    var availText = document.getElementById('main-product-avail-text');
    var availDot = document.querySelector('.main-product__avail-dot');
    var atcBtn = document.querySelector('.main-product__atc');
    var variantsEl = document.getElementById('main-product-variants-json');

    if (!pills.length || !variantInput || !variantsEl) return;

    var variantsData = [];
    try {
      variantsData = JSON.parse(variantsEl.textContent);
    } catch (e) { return; }

    var selectedOptions = [];
    document.querySelectorAll('.main-product__option-values').forEach(function (group, i) {
      var active = group.querySelector('.is-selected');
      selectedOptions[i] = active ? active.dataset.optionValue : null;
    });

    pills.forEach(function (pill) {
      if (pill.classList.contains('is-sold-out')) return;

      pill.addEventListener('click', function () {
        var optionIndex = parseInt(pill.dataset.optionIndex, 10);
        var newOptions = selectedOptions.slice();
        newOptions[optionIndex] = pill.dataset.optionValue;

        var match = variantsData.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === newOptions[i];
          });
        });
        if (!match) return;

        selectedOptions[optionIndex] = pill.dataset.optionValue;

        var group = pill.closest('.main-product__option-values');
        group.querySelectorAll('.main-product__option-pill').forEach(function (p) {
          p.classList.remove('is-selected');
          p.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('is-selected');
        pill.setAttribute('aria-checked', 'true');

        variantInput.value = match.id;

        if (priceEl) {
          while (priceEl.firstChild) priceEl.removeChild(priceEl.firstChild);
          var srHidden = document.createElement('span');
          srHidden.className = 'visually-hidden';
          srHidden.textContent = 'Price: ';
          priceEl.appendChild(srHidden);
          priceEl.appendChild(document.createTextNode(formatMoney(match.price)));
          if (match.compare_at_price > match.price) {
            priceEl.appendChild(document.createTextNode(' '));
            var compare = document.createElement('s');
            compare.className = 'main-product__compare-price';
            compare.textContent = formatMoney(match.compare_at_price);
            priceEl.appendChild(compare);
          }
        }

        if (availText) {
          /* Slime vs non-slime wording is decided in Liquid and parked on the
             element; fall back to the slime copy if the attribute is missing. */
          var inStockLabel = availText.getAttribute('data-available-label') || 'Made to Order';
          availText.textContent = match.available ? inStockLabel : 'Sold Out';
        }
        if (availDot) {
          availDot.classList.toggle('is-available', match.available);
        }
        if (atcBtn) {
          atcBtn.disabled = !match.available;
        }

        /* Afterpay Present messaging re-inits off this (snippets/afterpay.liquid). */
        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: { variant: match }
        }));
      });
    });
  }

  /* ── Upsell (Add Slime Saver!) ──────────────────────────────────────────── */

  /* An add-on upsell (data-upsell-addon, see snippets/hidden-product.liquid)
     may only join a cart that already holds a regular product. The cart
     drawer's state counts those (regularCount) and is re-rendered after every
     cart change the theme makes, so it is current by the time the shopper is
     back on this button. A count of 0 is double-checked against /cart.js in
     case the drawer is still catching up with an add made a moment ago. Any
     doubt resolves to "go ahead": the cart drawer removes an add-on that ends
     up alone, so the rule holds either way. */
  function cartHasRegularProduct() {
    var count = null;
    try {
      var el = document.querySelector('[data-cart-drawer] [data-cart-state]');
      count = el ? JSON.parse(el.textContent).regularCount : null;
    } catch (e) {}
    if (typeof count !== 'number' || count > 0) return Promise.resolve(true);
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        return (cart.items || []).some(function (item) {
          var props = item.properties || {};
          return !props._free_gift && String(item.product_type || '').trim().toLowerCase() !== 'hide';
        });
      })
      .catch(function () { return true; });
  }

  function initUpsell() {
    var btn = document.querySelector('.main-product__upsell');
    if (!btn) return;
    var isAddon = btn.hasAttribute('data-upsell-addon');
    var note = document.querySelector('.main-product__upsell-note');
    var noteTimer = null;

    function hideNote() {
      if (!note) return;
      clearTimeout(noteTimer);
      note.hidden = true;
      note.textContent = '';
    }

    function showNote() {
      if (!note) return;
      clearTimeout(noteTimer);
      note.hidden = false;
      /* Text goes in after the box is shown so screen readers announce it. */
      setTimeout(function () { note.textContent = note.getAttribute('data-message') || ''; }, 30);
      noteTimer = setTimeout(hideNote, 5000);
    }

    /* Anything added to the cart answers the note. */
    document.addEventListener('cart:updated', hideNote);

    btn.addEventListener('click', function () {
      var variantId = btn.dataset.upsellVariantId;
      if (!variantId || btn.dataset.busy === 'true') return;

      btn.dataset.busy = 'true';
      btn.setAttribute('aria-busy', 'true');

      var allowed = isAddon ? cartHasRegularProduct() : Promise.resolve(true);
      allowed.then(function (ok) {
        if (ok) return addUpsell(variantId);
        showNote();
        btn.dataset.busy = 'false';
        btn.setAttribute('aria-busy', 'false');
      });
    });

    function addUpsell(variantId) {
      hideNote();
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(res.status); })
      .then(function () {
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 2200);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'upsell' } }));
      })
      .catch(function () {})
      .finally(function () {
        btn.dataset.busy = 'false';
        btn.setAttribute('aria-busy', 'false');
      });
    }
  }

  /* Shopify money: cents → formatted string */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ── Quantity stepper ───────────────────────────────────────────────────── */
  function initQuantity() {
    var qtyBtns = document.querySelectorAll('.main-product__qty-btn');
    var qtyInput = document.querySelector('.main-product__qty-input');
    if (!qtyInput || !qtyBtns.length) return;

    qtyBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.dataset.qtyChange, 10);
        var current = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, current + delta);
      });
    });
  }

  /* ── Wishlist ───────────────────────────────────────────────────────────── */
  function initWishlist() {
    var btn = document.querySelector('.main-product__wishlist');
    if (!btn) return;

    var productId = String(btn.dataset.productId);
    var KEY = 'ksc_wishlist';
    var wishlist = [];

    try { wishlist = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}

    if (wishlist.indexOf(productId) !== -1) {
      btn.classList.add('is-added');
      btn.setAttribute('aria-pressed', 'true');
    }

    btn.addEventListener('click', function () {
      var isAdded = btn.classList.toggle('is-added');
      btn.setAttribute('aria-pressed', String(isAdded));
      try {
        if (isAdded) {
          if (wishlist.indexOf(productId) === -1) wishlist.push(productId);
        } else {
          wishlist = wishlist.filter(function (id) { return id !== productId; });
        }
        localStorage.setItem(KEY, JSON.stringify(wishlist));
      } catch (e) {}
    });
  }

  /* ── Recently Viewed — write ────────────────────────────────────────────── */
  function writeRecentlyViewed() {
    var dataEl = document.getElementById('main-product-rv-data');
    if (!dataEl) return;

    var productData;
    try { productData = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var KEY = 'ksc_recently_viewed';
    var MAX = 8;
    var items = [];

    try { items = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}

    items = items.filter(function (item) { return String(item.id) !== String(productData.id); });
    items.unshift(productData);
    items = items.slice(0, MAX);

    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
  }

  /* ── ATC — AJAX add to cart ─────────────────────────────────────────────── */
  function initATC() {
    var form = document.querySelector('.main-product__buy form');
    var btn = document.querySelector('.main-product__atc');
    if (!form || !btn) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled || btn.dataset.busy === 'true') return;

      btn.dataset.busy = 'true';
      btn.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(res.status); })
      .then(function () {
        btn.dataset.busy = 'false';
        btn.setAttribute('aria-busy', 'false');
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 2500);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'main-product' } }));
      })
      .catch(function () {
        btn.dataset.busy = 'false';
        btn.setAttribute('aria-busy', 'false');
      });
    });
  }

  /* ── Thumbnail arrow navigation ─────────────────────────────────────────── */
  function initThumbNav() {
    var prev = document.querySelector('.main-product__thumb-arrow--prev');
    var next = document.querySelector('.main-product__thumb-arrow--next');
    var strip = document.querySelector('.main-product__thumbnails');
    if (!prev || !next || !strip) return;

    var thumbs = Array.prototype.slice.call(strip.querySelectorAll('.main-product__thumb'));
    if (!thumbs.length) return;

    var offset = 0;

    function visibleCount() {
      return window.innerWidth <= 767 ? 4 : 3;
    }

    function isHorizontal() {
      return window.innerWidth <= 767;
    }

    function stepSize() {
      if (thumbs.length < 2) {
        return isHorizontal() ? thumbs[0].offsetWidth : thumbs[0].offsetHeight;
      }
      var r1 = thumbs[0].getBoundingClientRect();
      var r2 = thumbs[1].getBoundingClientRect();
      return isHorizontal() ? (r2.left - r1.left) : (r2.top - r1.top);
    }

    function update() {
      var vis = visibleCount();
      var max = Math.max(0, thumbs.length - vis);
      if (thumbs.length <= vis) {
        prev.style.visibility = 'hidden';
        next.style.visibility = 'hidden';
        strip.style.transform = '';
        return;
      }
      prev.style.visibility = '';
      next.style.visibility = '';
      offset = Math.max(0, Math.min(offset, max));
      var px = offset * stepSize();
      strip.style.transform = isHorizontal()
        ? 'translateX(-' + px + 'px)'
        : 'translateY(-' + px + 'px)';
      prev.disabled = offset === 0;
      next.disabled = offset >= max;
    }

    prev.addEventListener('click', function () { offset--; update(); });
    next.addEventListener('click', function () { offset++; update(); });
    window.addEventListener('resize', function () { offset = 0; update(); });

    update();
  }

  /* ── Scroll-follow: image translates within its frame on page scroll ────── */
  function initScrollFollow() {
    var mediaWrap = document.querySelector('.main-product__media-wrap');
    var media = mediaWrap && mediaWrap.querySelector('.main-product__media');
    if (!mediaWrap || !media) return;
    if (window.innerWidth <= 767) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var range = 36; // max ± translate in px — bounded inside the frame
    var ticking = false;
    var inView = true;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView) onScroll();
      }, { threshold: 0 });
      io.observe(mediaWrap);
    }

    function update() {
      ticking = false;
      if (!inView) return;
      var rect = mediaWrap.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var totalDist = rect.height + vh;
      var traveled = vh - rect.top;
      var progress = Math.max(0, Math.min(1, traveled / totalDist));
      var translate = (progress - 0.5) * 2 * range;
      media.style.setProperty('--scroll-follow-y', translate.toFixed(2) + 'px');
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ── Boot ───────────────────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
    initVariantPicker();
    initQuantity();
    initWishlist();
    writeRecentlyViewed();
    initATC();
    initThumbNav();
    initScrollFollow();
    initUpsell();
    initBreadcrumb();
  });

  /* ── Breadcrumb: name the collection the shopper came through ─────────────
     Product URLs are the bare /products/<handle>, so Liquid has no collection
     context and the middle crumb is rendered as a best guess from the
     product's own collections. section-collection.js records the collection
     being browsed; if that is one this product genuinely belongs to, it is the
     truer answer and replaces the guess.

     The membership check is the whole safety of this: without it, browsing one
     collection and then landing on a product from somewhere else entirely
     would have the crumb claim a collection the product is not in. */
  function initBreadcrumb() {
    var nav = document.querySelector('.main-product__breadcrumb');
    if (!nav) return;

    var remembered;
    try {
      remembered = JSON.parse(sessionStorage.getItem('ksc_last_collection') || 'null');
    } catch (err) { return; }
    if (!remembered || !remembered.handle || !remembered.url || !remembered.title) return;

    var handles = (nav.getAttribute('data-product-collections') || '').split(/\s+/);
    if (handles.indexOf(remembered.handle) === -1) return;

    /* Crumb one is already Shop All; naming it again reads "Shop All › Shop All". */
    if (remembered.url === nav.getAttribute('data-shop-all-url')) return;

    var li = nav.querySelector('[data-breadcrumb-collection]');
    if (li) {
      var link = li.querySelector('a');
      var name = li.querySelector('[itemprop="name"]');
      if (link) link.setAttribute('href', remembered.url);
      if (name) name.textContent = remembered.title;
      return;
    }

    /* No middle crumb server-side — every collection this product is in was on
       the "never guess these" list. The shopper still came through one of them,
       so build the crumb rather than leaving the trail incomplete. */
    var productLi = nav.querySelector('[data-breadcrumb-product]');
    if (!productLi) return;

    li = document.createElement('li');
    li.setAttribute('itemprop', 'itemListElement');
    li.setAttribute('itemscope', '');
    li.setAttribute('itemtype', 'https://schema.org/ListItem');
    li.setAttribute('data-breadcrumb-collection', '');

    var a = document.createElement('a');
    a.setAttribute('itemprop', 'item');
    a.setAttribute('href', remembered.url);

    var span = document.createElement('span');
    span.setAttribute('itemprop', 'name');
    span.textContent = remembered.title;

    var pos = document.createElement('meta');
    pos.setAttribute('itemprop', 'position');
    pos.setAttribute('content', '2');

    a.appendChild(span);
    li.appendChild(a);
    li.appendChild(pos);
    productLi.parentNode.insertBefore(li, productLi);

    /* The product crumb was position 2 while it was second in the list. */
    var productPos = productLi.querySelector('meta[itemprop="position"]');
    if (productPos) productPos.setAttribute('content', '3');
  }
}());
